// extracted by mini-css-extract-plugin
export default {"gradientText":"GradientText_gradientText__piNu2"};